export default "__VITE_ASSET__DzlusG0r__"